export const WA_DOC_LINK = 'https://wadocs.netcorecloud.com/';
export const DOC_LINK = 'https://emaildocs.netcorecloud.com/docs/';
export const DOC_V1_LINK = 'https://emaildocs.netcorecloud.com/v1.0/docs/';
// export const DEVELOPER_DOC_LINK = 'https://emaildev.netcorecloud.com/';
export const DEVELOPER_DOC_LINK = 'https://emaildev.netcorecloud.com/docs/pepipost-api/';
export const API_LINK = 'https://emailapi.netcorecloud.net/';

export const LOG_OUT_URL = 'logout';
export const API_URL = 'http://192.168.41.60:5000/';
export const WARNING_MSG = 'Something went wrong!';
export const WARNING_MSG_TRY_LATER = 'Something went wrong! Please try again later';
export const WHATSAPP_SERVER_AUTH = 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJuZXRjb3JlX3NhbmRib3giLCJleHAiOjI0MTUzNDU2MzR9.7lMWQOTzJs2VVmKrF4G1I2JmMtMgBrAL7jHSOt1f6HefHKZnksu5twKU49nAm9A27fxKIKZCvKkaXszdvfEgsA';

// Audit logs API Constants
export const GET_ALL_AUDIT_LOGS = 'AuditLog/list';
export const GET_ALL_AUDIT_ACTIVITIES = 'AuditLog/activities';
export const GET_ALL_AUDIT_USER_NAMES = 'AuditLog/usernameOrApiName';

// Getting started API Constants
export const GETTING_STARTED_API_URL = 'Homepage';
export const GETTING_STARTED_TIMEZONE_URL = 'Homepage/set_timezone';
export const GETTING_STARTED_TIMEZONE_FIRST_URL = 'Homepage/set_timezone_first';
export const DASHBOARD_GET_STARTED_STEPS = 'Homepage/steps_dashboard';
export const REFER_FRIEND = 'Homepage/refer_friend';
export const RESEND_CONFIRMATION = 'userinfo/resendConfirmationLink';
export const UPDATE_ACTIVATION_EMAIL_ADDRESS = 'userinfo/updateEmailAddress';
export const CHECK_ACCOUNT_STATUS = 'userinfo/checkAccountStatus';
export const DELETE_ACCOUNT = 'userinfo/deleteAccountNotification';
export const CHECK_OLD_PAID_CLIENT = 'userinfo/checkOldPaidClient';
export const REDIRECT_MANAGE = 'userinfo/redirectManage';
export const REF_DETAILS = 'userinfo/rdetails';
export const PROFILE = 'profile';


export const ACCOUNT_DETAILS = 'accountDetails/accountDetails';
export const ACCOUNT_VERIFICATION_STATUS = 'accountDetails/accountVerificationStatus';
export const ACCOUNT_PHONE_NUMBERS = 'accountDetails/phoneNumbers';
export const ACCOUNT_OBA_ELIGIBILITY = 'accountDetails/obaEligibility';
export const ACCOUNT_OBA_STATUS = 'accountDetails/obaStatus';
export const ACCOUNT_OBA_APPLY = 'accountDetails/applyOBA';
export const ACCOUNT_OBA_DATA = 'accountDetails/getOBAProfile';

// Webhooks API Constants
export const WEBHOOK_GLOBALDATA = 'webhook/getWebhook';
export const WEBHOOK_GLOBALDATA_VERIFY = 'webhook/verifyWebhook';
export const WEBHOOK_GLOBALDATA_SUBMIT = 'webhook/saveWebhook';
export const WEBHOOK_CUSTOMEDATA = 'webhook/webhooks_customdata';
export const WEBHOOK_CUSTOMEDATA_VERIFY = 'webhook/verifyWebhook';
export const INBOUND_VERIFY_WEBHOOK = 'inbound/verifyWebhook';
export const WEBHOOK_CUSTOMEDATA_SUBMIT = 'webhook/saveWebhook';
export const WEBHOOK_DATA = 'webhook/webhookDetails';
export const WEBHOOK_DATA_SUBMIT = 'webhook/addWebhook';
export const FAILED_WEBHOOK_REPORT = 'webhook/getFailureReport';
export const GET_PUBLISH_FEEDS = 'webhook/listRepublishWebhooks';
export const REPUBLISH_WEBHOOK ='webhook/addRepublishWebhook';
export const GET_WEBHOOK_URLS = 'webhook/getWebhookUrls';

// Domain Setting API Constants
export const DOMAIN_DATA = 'domain';
export const DOMAIN_ADD = 'domain/add_domain';
export const VERIFY_DOMAIN = 'domain/verify_domain';
export const VERIFY_CNAME_DOMAIN = 'Domain/verify_cname_domain';
export const VERIFY_SPF = 'domain/verifyspf';
export const VERIFY_DKIM = 'domain/verifydkim';
export const VERIFY_CNAME = 'domain/verify_cname';
export const SAVE_ENVELOP = 'domain/save_envelope';
export const DOMAIN_DELETE = 'domain/deleteDomain';
export const CHECK_APPROVAL = 'domain/checkapproval';
export const SEND_APPROVAL = 'domain/sendapproval';
export const DOMAIN_EVALUATION_DETAILS = 'domain/domain_action';
export const DOWNLOAD_DNS_SETTINGS = 'domain/download_summary';
export const SAVE_DOMAIN_ACTION_DETAILS = 'domain/save_action_state';
export const REJECTED_DOMAIN_REDIRECTION =
  DOC_LINK + 'what-to-do-if-your-sender-domain-is-rejected';

// API for getting suppression email addresses
export const GET_SUPPRESSION_EMAIL_ADDRESS = 'Suppression/get_suppression_email_addresses';
export const GET_SUPPRESSION_EMAIL_COUNTS = 'Suppression/get_total_suppr_email_count';
export const GET_SUPPRESSION_DOMAIN = 'Suppression/get_suppression_domain';
export const MAKE_BLACKLIST_EMAIL = 'Suppression/blacklist_email';
export const MAKE_WHITELIST_EMAIL = 'Suppression/whitelist_email';
export const MAKE_BLACKLIST_DOMAIN = 'Suppression/blacklist_domain';
export const MAKE_WHITELIST_DOMAIN = 'Suppression/whitelist_domain';
export const DOWNLOAD_SUPPRESSION_EMAIL = 'Suppression/download_suppression_email_addresses';
export const DOWNLOAD_SUPPRESSION_DOMAIN = 'Suppression/download_suppression_domain';
export const SYNC_SUPPRESSION = 'Suppression/sync_suppressions';
export const BLACKLIST_SYNC_MAP_LIST = 'Suppression/sync_map_list';
export const BLACKLIST_SYNC_MAP_ADD = 'Suppression/sync_map_add';
export const BLACKLIST_SYNC_MAP_DELETE = 'Suppression/sync_map_delete';


// Billing API Constatnts
export const ADD_NEW_CARD = 'billing/add_new_card';
export const ADD_NEW_CARD_CHARGE_PENDING_BILL = 'billing/add_new_card_carge_pending';
export const ADD_NEW_CARD_AND_MAKE_PRIMARY = 'billing/add_new_card_and_make_primary';
export const ADD_NEWCARD_CHARGE_AND_MAKE_PRIMARY = 'billing/add_newcard_charge_and_make_primary';
export const NEW_CHARGE_PRIMARY_CARD = 'billing/charge_from_primary_card';
export const SEND_CUSTOM_PRICE_REQUEST = 'billing/send_custom_price_request';
export const BILLING_HISTORY = 'billing/billing_history';
export const DOWNLOAD_INVOICE = 'billing/download_invoice';
export const GET_APPLIED_COUPON_CODE = 'billing/get_applied_coupon_code';
export const CHECK_PRPMO_CODE = 'billing/check_promo_code';
export const GET_EMAIL_CREDITS = 'billing/get_available_email_credits';
export const GET_NEW_SLAB_EMAIL_CREDITS = 'billing/get_available_email_credits_dashboard';
export const GET_AVAILABLE_EMAIL_CREDITS = 'billing/get_available_open_credits';
export const GET_POSTPAID_BILLING_DETAILS = 'billing/postpaid_billing_details';
export const UPDATE_AUTO_RENEW = 'billing/update_auto_renew_values';
export const VALIDATE_AUTO_RENEW = 'billing/validate_auto_renew_values';
export const GET_OLD_BILLING_PYINTENT = 'billing/get_bill';
export const GET_REDEEM_HISTORY = 'billing/get_redeem_history';
export const ENABLE_AUTO_REDEEM = 'billing/enable_auto_redeem';
export const UPDATE_AUTO_RENEW_STATUS = 'billing/update_auto_renew_status';
export const REDEEM_OPEN_CREDITS = 'billing/redeem_open_credits';
export const PREVIEW_INVOICE = 'billing/preview_invoice';
export const RETRIVE_CREDIT_CARD_DETAILS = 'billing/retriving_credit_card';
export const SAVE_BILLING_DETAILS = 'billing/save_billing_deatils';
export const GET_BILLING_DETAILS = 'billing/get_billing_details';
export const APPLY_COUPON = 'billing/apply_coupon';
export const MAKE_PRIMARY_CARD = 'billing/make_primary_card';
export const MAKE_PRIMARY_CARD_CHARGE_UNPAID_BILL = 'billing/make_primary_card_charge_unpaidbill';
export const DELETE_CARD = 'billing/delete_card';
export const GET_SLAB_PLAN = 'billing/get_plan_slab';
export const GET_CURRENT_PLAN = 'billing/get_current_plan';
export const MAKE_PAYMENT = 'billing/make_payment';
export const MAKE_PAYMENT_EXISTING_CARD = 'billing/make_payment_existing_card';
export const GET_AUTORENEW_DETAILS = 'billing/get_recurring_details';
export const GET_SPECIAL_PRICING = 'billing/get_special_pricing';
export const GET_PLAN_TYPE = 'billing/get_plan_type';
export const CHECK_PEPI_CLIENT = 'billing/check_pepipost_client';
export const FETCH_CREDIT_MANAGEMENT_GRAPH_DATA = 'billing/get_credit_management_graph_data';
export const CHECK_UNLIMITED_CODE_APPLIED = 'billing/check_unlimited_code_applied';
export const DOMAIN_APPROVE_CHECK = 'billing/check_domain_approved';
export const CHECK_SUBUSER = 'billing/check_subuser';
export const CHECK_FALCON_PREPAID = 'billing/check_falcon_prepaid';
export const GET_TRANSACTION_DATA = 'billing/get_transaction_data';
export const GET_ALL_INVOICE_DATA = 'billing/get_invoice_data';
export const GET_POSTPAID_REDEEM_HISTORY = 'billing/get_postpaid_redeem_history';
export const GET_UPGRADE_PLAN_DETAILS = 'billing/get_all_plan_details';
export const UPDATE_DOWNGRADE_REQUEST = 'billing/update_downgrade_request';
export const PLAN_DETAILS = 'billing/plan_details';
export const PREFERRED_PLAN = 'billing/preferred_plan';
export const CANCEL_UPGRADE = 'billing/cancel_upgrade';
export const SUB_ACCOUNT = 'billing/sub';
export const PREFFERED_PLAN_DETAILS = 'billing/preferred_plan_details';
export const GET_PLAN_DURATION = 'billing/plan_duration';
export const GET_CLIENT_PAYMENT_METHOD = 'billing/client_payment_method';
export const GET_PAYMENT_DETAILS = 'billing/get_payment_details';
export const CANCEL_DOWNGRADE = 'billing/cancel_downgrade';
export const TALK_TO_US = 'billing/talk_to_us';
export const BILLING_ON_FIRST = 'billing/on_first';
export const CREATE_CUSTOMER = 'billing/create_customer';
export const GET_FAILED_PAYMENT_DETAILS = 'billing/failed_payment';
export const FAILED_PAYMENT_CONFIRM = 'billing/failed_payment_confirm';

export const GET_RCS_BILLING_DETAILS = 'billing/get_rcs_billing_details';
export const SAVE_RCS_BILLING_DETAILS = 'billing/save_rcs_billing_deatils';

// Warmup slap API Constants
export const WARMUPSLAB_DETAILS = 'userinfo/warmupSlab/';
export const READ_NOTIFICATION = 'userinfo/markasread';
export const GET_ALL_NOTIFICATION = 'userinfo/getNotifications';
export const INCREASE_SLAB_REQUEST = 'userinfo/increaseSlabRequest';
export const GET_HEADER_NOTIFICATION = 'userinfo/getHeaderNotifications';
export const GET_DETAILS = 'userinfo/details';


// Mail Setting
export const LIST_MAIL_SETTINGS = 'Mailsettings/list_settings';
export const UPDATE_MAIL_SETTINGS = 'Mailsettings/updateSettingValue';
export const UPDATE_UNSUBSCIBE_DETAILS = 'Mailsettings/updateunsubscribe';
export const TOGGLE_MAIL_SETTINGS = 'Mailsettings/updateSettings';


// Integration Setting
export const GET_SMTP_INFO = 'Integrations/get_smtp_info';
export const GET_API_INFO = 'Integrations/get_api_key';
export const toggle_PII_Hashing = 'setting/updateRcsConfig'; 
export const GET_SMTP_API_KEY = 'Integrations/get_smtp_api_key';
export const TEST_MAIL = 'Integrations/testmail';
export const RESET_SMTP_PASSWORD = 'Integrations/changeSMTP';
export const SET_SMTP_PASSWORD = 'Integrations/setSMTPPass';
export const REQUEST_OTP = "Integrations/request_otp";
export const VERIFY_OTP = "Integrations/verify_otp";
export const ADD_RESTRICTION_IP = 'Integrations/add_restriction_ip';
export const GET_RESTRICTION_IP = 'Integrations/get_restriction_ip';

// Profile constants
export const GET_PROFILE_INFO = 'Profile/get_profile_info';
export const GET_COUNTRY_LIST = 'Profile/get_country_list';
export const UPDATE_PROFILE_INFO = 'Profile/update_profile_info';
export const CHANGE_PASSWORD = 'Profile/change_password';
export const CHANGE_EMAIL = 'Profile/change_email';
export const GET_EMAIL_DETAILS = 'Profile/get_email_details';
export const RESEND_EMAIL_VERIFICATION = 'Profile/resend_link';
export const GET_PWD_STATUS = 'Profile/policy';
export const SAVE_USERUSER_AGENT_DETAILS = 'Profile/save_user_details';
export const UPDATE_USER_AGENT_DETAILS = 'Profile/update_user_details';
export const GET_TWOFA_EMAIL_DETAILS = 'Profile/get_twofa_details';
export const CHANGE_TWOFA_STATUS = 'Profile/change_twofa_status';
export const CHANGE_TWOFA_EMAIL = 'Profile/change_twofa_email';
export const RESEND_TWOFA_EMAIL_VERIFICATION = 'Profile/resend_twofa_link';
export const SKIP_SET_PASSWORD = 'Profile/skip_set_password';
export const CHANGE_TWOFA_GA_STATUS = 'Profile/change_twofa_ga_status';
export const GET_TWOFA_GA_DETAILS = 'Profile/get_twofa_ga_details';
export const GET_QR_SECRET = 'Profile/get_ga_secret';
export const VERIFY_QR_SECRET = 'Profile/verifyOTP';
export const GET_TWOFA_STATUS = 'Profile/twofa_status';

// Two-factor auth (sensitive-action) bootstrap + verification
// NOTE: Backend must implement these endpoints to return { authType, validTill } and verify codes.
export const GET_TWO_FACTOR_AUTH_STATUS = 'Profile/twofaDetails';

// Mail Alerts
export const LIST_MAIL_ALERTS = 'Mailalert/list_mail_alerts';
export const ADD_MAIL_ALERTS = 'Mailalert/add_mail_alert';
export const DELETE_ALERTS = 'Mailalert/deletealert';

// fetch Mobile number and country data

export const FETCH_MOBILE_NUMBER_DATA = "Report/list_phone_num";
export const FETCH_MOBILE_NUMBER_HEALTH_DATA = "campaign/phone_num_quality";
export const SAVE_ACCOUNT_SETTINGS = 'setting/save_account_settings';
export const GET_ACCOUNT_SETTINGS = 'setting/account_settings';

//Manage User

export const LIST_USER_EMAIL = 'Report/list_email';
export const DELETE_USER_EMAIL = 'Report/remove_email';
export const SAVE_USER_EMAIL = 'Report/add_email';
export const EDIT_USER_EMAIL = 'Report/edit_email';
export const USER_RESEND_CONFIRMATION = 'Report/resend_confirmation';

// Domain
export const DOMAIN_LISTING = 'Domain/domlist';
export const ADD_DOMAIN = 'domain/add_domain';
export const ARCHIVE_DOMAIN = 'domain/deleteDomain';
export const FASTRACK_DOMAIN_APPROVAL = 'domain/query_email';
export const GET_DOMAIN_TRACKING_DETAILS = 'domain/get_domainwise_envelope_setting';
export const SET_DOMAIN_TRACKING_DETAILS = 'domain/set_domainwise_envelope_setting';
export const GET_DOMAIN_SUMMARY = 'domain/get_domain_summary';
export const TEST_MAIL_DOMAIN = 'domain/testmail';
export const CHECK_DOM = 'domain/checkDom';

// Analytics
export const LIST_TAG_NAMES = 'analytics/getAllTags';
export const LIST_TAG_NAMES_MASTER = 'analytics/getAllTagsMaster';
export const MAIL_SUMMARY_TAGS = 'analytics/getTagWiseSummary';
export const MAIL_SUMMARY_TAGS_CSV = 'analytics/getTagWiseSummaryCSV';
export const ANALYTICS_GRAPH = 'analytics/getTagWiseSummary';
export const DELETE_TAG = 'analytics/deleteTag';

// 1000 emails for
export const DEFAULT_MAIL_COUNT = 1000;
export const DEFAULT_EMAIL_PRICE = 0.20;


//
export const GET_LIVEFEED_INFO = 'livefeed/fetchtablefeed';
export const DOWNLOAD_LIVE_REPORT = 'livefeed/downloadreport';
export const SHARE_LIVE_REPORT = 'livefeed/sharereport';
export const SEND_LIVE_FEED = 'livefeed/sendemailreport';

// SubUser
export const GET_ALL_SUBUSERS = 'subuser/getAllSubusers';
export const CREATE_SUBUSER = 'subuser/create';
export const MODIFY_SUBUSER = 'subuser/modify';
export const GET_SUBUSER_DETAILS = 'subuser/getSubuserDetails';
export const SUBUSER_RESET_PASSWORD = 'Subuser/resetPassword';

// template
export const GET_ALL_TEMPLATES = 'template/getAllTemplate';
export const DUPLICATE_TEMPLATE = 'template/duplicate_template';
export const WHATSAPP_RENAME_TEMPLATE = 'template/renameTemplate';
export const PREVIEW_TEMPLATE = 'template/previewTemplate';
export const SAVE_TEMPLATE = 'template/saveTemplate';
export const DELETE_TEMPLATE = 'template/deleteTemplate';
export const SAVE_DRAFT_TEMPLATE = 'template/save_template';
export const SYNC_TEMPLATE = 'template/sync_templates';
export const GET_DRAFT_TEMPLATE_DATA = 'template/view_template_draft';
export const SAVE_ATTRIBUTE = "template/save_attributes";
export const TEST_TEMPLATE = "template/testmessage";
export const GET_ALL_FLOWS = 'template/flow_list';
export const GET_FLOW_SCREENS = 'template/flow_screens';
export const FLOW_PREVIEW = 'template/flow_preview'; 

// rcs template
export const SAVE_RCS_DRAFT_TEMPLATE = 'RcsTemplate/create';
export const SAVE_RCS_TEMPLATE = 'template/saveTemplate';
export const GET_ALL_RCS_TEMPLATE = 'RcsTemplate/index';
export const GET_TEMP_BY_ID = 'RcsTemplate/getTemplate?template_id=';
export const RCS_TEST_TEMPLATE = 'RcsTemplate/testTemplate';
export const RCS_DELETE_TEMPLATE = 'RcsTemplate/deleteTemplate';
export const SYNC_RCS_TEMPLATE = 'RcsTemplate/syncTemplates';
export const RCS_DUPLICATE_TEMPLATE = 'RcsTemplate/duplicateTemplate';
export const GET_RCS_TEMPLATE_TYPES = 'RcsTemplate/fetchTemplateType';

// bucketwise report
export const GET_BUCKETWISE_REPORT = 'Bucketwise/bucketwise_report';
export const GET_BUCKETWISE_REPORT_DOWNLOAD = 'Bucketwise/bucketwise_report_download';
export const GET_BUCKETWISE_DETAILS = 'Bucketwise/bucket_details';
export const GET_BUCKETWISE_DETAILS_DOWNLOAD = 'Bucketwise/bucket_details_download';
// Dashboard
export const DASHBOARD_HISTORY_GRAPH = 'dashboard/fetchDashboardData';
export const GET_CLIENT_ID = 'dashboard/fetchClientId';

export const NO_DATA_FOUND = 'No data available to display.';
export const LOADING = 'Loading...';
export const NONE_FOUND = '<i>None found</i>';
export const UNDEFINED_TEXT = `<i>Not Defined</i>`;
export const DOMAIN_URL_ERROR = 'Please enter a valid URL.';




// Sub Accounts
export const LIST_SUBACCOUNT_DETAILS = 'SubAccounts/list';
export const CREATE_SUBACCOUNT = 'SubAccounts/create';
export const DELETE_SUBACCOUNT = 'SubAccounts/delete';
export const UPDATE_SUBACCOUNT_STATUS = 'SubAccounts/update';
export const CLIENT_TYPE = 'SubAccounts/clientType';
export const SUBACCOUNT_RESEND_LINK = 'SubAccounts/subaccountResendConfirmation';
export const CHECK_EMAIL_STATUS = 'SubAccounts/checkEmailStatus';

export const UPDATE_SUBACCOUNT_PASSWORD = 'Profile/change_password_subaccount';
export const GET_DOMAIN_LIST = 'SubAccounts/getDomainList';
export const UPDATE_DOMAIN_STATUS = 'Domain/allowManageDomain';
export const ADD_REMOVE_DOMAIN_SUBACCOOUNT = 'Domain/addDomain_SubAccount';
export const POST_REQUEST_FOR_DEDICATED_IP = 'billing/request_dedicatedIp';
export const SEND_REQUEST_FOR_DEDICATED_IP = 'dedicatedip/request_dedicatedIp';
export const GET_AVAILABLE_DEDICATED_IP = 'dedicatedip/available_ip';
export const GET_ASSIGNED_IP = 'dedicatedip/assignedip_list';
export const DELETE_ASSET = 'dedicatedip/delete_asset';
export const BILLING_GET_DEDICATEDIP = 'billing/get_dedicatedIp';
export const PURCHASE_DEDICATEDIP = 'billing/purchase_dedicatedIp';
export const GET_ALL_SUBACCOUNTS = 'SubAccounts/getAllSubaccounts';


// Dedicated IP - Assignment
export const CHECK_ELIGIBLE_IP_PURCHASE = 'dedicatedip/IpPurchaseEligibility';
export const GET_MAX_ASSIGN_LIST = 'dedicatedip/max_and_assigned_ip';
export const GET_BATCH_LIST = 'dedicatedip/batchlist';
export const SET_DEFAULT_IP = 'dedicatedip/set_default';   // set assigned Ip As default IP
export const MANAGE_UNSUB_IP = 'dedicatedip/manageIPSubscription';   // set assigned Ip As default IP

export const UPDATE_IP_ASSIGNMENT = 'dedicatedip/submitAssignment';
export const LIST_IP_ASSIGNMENT_BATCHWISE = 'dedicatedip/list_batch_wise';
export const LIST_IP_ASSIGNMENT_DOMAINWISE = 'dedicatedip/list_domain_wise';
export const LIST_IP_ASSIGNMENT_SUB_ACCOUNTWISE = 'dedicatedip/list_sub_account_wise';



// export const DOWNLOAD_USAGE_SUMMARY = 'billing/downloadUsageSummary';
export const USAGE_SUMMARY = 'Billing/usage_summary';
export const GTE_SUBACCOUNT_BILLING_DETAILS = 'Billing/getSubAccountBilling';
export const CHANGE_CREDIT_TYPE = 'Billing/changeCreditType';
export const UPDATE_RECURRING = 'Billing/updateRecurring';
export const MANAGE_CREDIT = 'Billing/MangeCreditsSubaccounts';
export const ALL_SUBACCOUNT_CREDIT_HISTORY = 'Billing/CreditHistory';
export const CHECK_DOMAIN_ADDITION_PERMISSION = 'Domain/checkDomainPermission';
export const LIST_SUBACCOUNT = 'analytics/getSubAccountsList';
export const DOWNLOAD_ACCOUNT_LOG = 'Billing/CreditHistoryDownload';
export const DOWNLOAD_USAGE_SUMMARY = 'Billing/usage_summary_download';
export const US_CLIENTS_BILLING_SUMMARY = 'Billing/getUsClientsBilling';


export const CREATE_FIRST_PROMO_ACCOUNT = 'Referral/create_referral_account';
export const CHECK_ACCOUNT = 'Referral/check_account';
export const REFERRAL_DENY = 'Referral/deny';
// Sandbox api end
export const SANDBOX_DOMAIN_NAME = 'pepisandbox.com';
export const SANDBOX_ADD_RECP = 'sandbox/add_recp';
export const SANDBOX_LIST_RECP = 'sandbox/list_recp';
export const SANDBOX_DELETE_RECP = 'sandbox/delete_recp';

export const SANDBOX_RESEND_RECP_VERIFICATION = 'sandbox/resend_confirmation';
export const ALL_DOMAIN_LIST = 'sandbox/list_domains';
export const SANDBOX = 'sandbox';
export const LOCATIONWISE_EP = 'profile/locationwise_ep';


//whatapp api calls
//token generated apis
export const WHATSAPP_TOKEN = 'userinfo/clientAuth';
export const WHATSAPP_SEND_TOKEN = 'api/login';

//whatsapp template

export const LIST_WHATSAPP_CATEGORY = 'category/';
export const LIST_WHATSAPP_SOURCE = 'api/sources/';
export const LIST_WHATSAPP_LANGUAGE = 'language/';
export const ADD_WHATSAPP_TEMPLATE = 'template/add';
export const LIST_WHATSAPP_TEMPLATE = 'template/list';
export const WA_TEMPLATE_CONFIG = 'template/template_conf';
export const LIST_WHATSAPP_TEMPLATES = 'template/lists';
export const TEMPLATE_WHATSAPP_EDIT = 'template/edit';

//Whatsapp optin optout

export const LIST_WHATSAPP_OPTIN = 'optin/';
export const LIST_WHATSAPP_OPTOUT = 'optout/';
export const FETCH_OTINOPTOUT_DATA = 'optin/optData/';
export const BULK_WHATSAPP_OPTIN = 'optin/bulkOpt';
export const BULK_WHATSAPP_OPTOUT = 'optout/bulkOpt';
export const LIST_WHATSAPP_CONTACTS_LOGS = 'optin/contactsLog';
export const DOWNLOAD_CONTACT_CSV = 'optin/download_csv';

// WHATSAPP BLOCKLISTING APIS
export const LIST_WHATSAPP_BLOCKLISTING = 'blocklist/';
export const BULK_WHATSAPP_BLOCKLISTING = 'blocklist/bulk';
export const DOWNLOAD_WHATSAPP_BLOCKLISTING = 'blocklist/download_csv';

//Whatsapp Reports api

export const TEMPLATE_WHATSAPP_REPORT = 'report/template';
export const TEMPLATE_WHATSAPP_GRAPH = 'report/template_graph';
export const CONVERSATION_WHATSAPP_REPORT = 'report/conversation';
export const TEMPLATE_WHATSAPP_MEDIA = 'report/media/';
export const DASHBOARD_WHATSAPP_GRAPH = 'report/dashboard/';

// Rate limit banner APIs
export const GET_WHATSAPP_RATE_LIMIT_BANNER = 'WhatsappAccount/usage';
export const GET_RCS_RATE_LIMIT_BANNER = 'RcsAccount/usage';

// Whatsapp Settings Api

export const GET_WHATSAPP_API_KEY = 'Integrations/show_api_key';
export const GET_WHATSAPP_SETTINGS = 'setting/';
export const GET_WHATSAPP_CONFIG_BY_KEY = 'setting/config_by_key';
export const GET_LIST_API_KEY = 'setting/list_api_key';
export const TOGGLE_AUTO_REPLY = 'setting/update_canned_responses';
export const POST_UPDATE_CANNED_RESPONSE = 'setting/add_update_canned_intent';
export const TOGGLE_CANNED_RESPONSE = 'setting/update_canned_intent_status';
export const DELETE_CANNED_RESPONSE = 'setting/delete_canned_intent';
export const POST_UPDATE_API_KEY = 'setting/update_api_key';
export const POST_GENERATE_API_KEY = 'setting/generate_api_key';
export const POST_WHATSAPP_SETTINGS = 'setting/save';
export const POST_WHATSAPP_ENCRYPTION_SETTINGS = 'setting/save_encryption';
export const POST_WHATSAPP_MESSAGE = 'api/send_message';
export const POST_RCS_MESSAGE = 'report/send_message';
export const POST_WHATSAPP_SAVE_PROFILE = 'setting/save_profile';
export const GET_WHATSAPP_PROFILE = 'setting/profile';
export const POST_WHATSAPP_PROFILE_PHOTO = 'setting/profile_photo';
export const POST_WHATSAPP_TEMPLATE = 'template/create';
export const DELETE_WHATSAPP_TEMPLATE = 'template/delete';
export const UPLOAD_SAMPLE_FILE = 'template/add_sample';
export const RESUME_WHATSAPP_TEMPLATE = 'template/reactivate';

export const GET_WHATSAPP_WEBHOOK = 'setting/webhooks';
export const POST_WHATSAPP_WEBHOOK = 'setting/save_webhooks';
export const POST_WHATSAPP_WEBHOOK_TEST = 'setting/test_webhooks';
export const GET_WEBHOOKS_TABLE_SETTINGS = 'webhook/webhook_configs';
export const GET_WHATSAPP_QUALITY = 'setting/phone_quality';
'accountobaEligibility'

//webhooks
export const GET_WEBHOOKS = 'webhook/index';
export const POST_ADD_WEBHOOK = 'webhook/add_webhook';
export const POST_CHANGE_STATUS = 'webhook/change_status';
export const POST_TEST_WEBHOOK_URL = 'webhook/test_webhook';

export const RCS_GET_WEBHOOKS = 'RcsWebhook/webhookUrls';
export const RCS_POST_ADD_WEBHOOK = 'RcsWebhook/add_webhook';
export const RCS_POST_CHANGE_STATUS = 'RcsWebhook/change_status';
export const RCS_POST_TEST_WEBHOOK_URL = 'RcsWebhook/test_webhook';
export const RCS_GET_WEBHOOKS_TABLE_SETTINGS = 'RcsWebhook/webhook_configs';

export const SMS_SSO = 'SSO/sms_details';
export const PANDA_URL = 'https://sso.mytoday.com/sso/CpaasSsoAuth';

// WhatsApp payment integration
export const INTEGRATION_LIST = 'integration/integration_lists';
export const CREATE_CONNECTION = 'integration/create_connection';
export const REMOVE_CONNECTION = 'integration/remove_connection';
export const GENERATE_PAYMENT_CONFIG_LINK = 'integration/generate_payment_connection_oauth_link';
export const GLOBAL_SAMPLE_DATA = 'template/global_sample_data';

// prepaid billing
export const CREDIT_OVERVIEW = 'billing/credit_overview';
export const BILLING_DETAILS = 'billing/billing_details';
export const REQUEST_CREDITS = 'billing/request_credits';
export const REQUEST_PAYMENT_HISTORY = 'billing/request_and_payment_history';
export const PAYMENT_DETAILS = 'billing/payment_details';
export const MAKE_PREPAID_PAYMENT = 'billing/pay';
export const CHECK_AND_PROCEED_FOR_PAYMENT = 'billing/check_and_proceed_payment';
export const SEND_EMAIL_INVOICE = 'billing/email_prepaid_invoice';
export const CHECK_REQUEST_STATUS = '/billing/check_prepaid_request_status';
// SMS APIs
export const SMS_AUTH = 'Auth';
export const SMS_DASHBOARD_DATA = 'Dashboard/fetchDashboardData';
export const SMS_EXECUTIVE_SUMMARY = 'Report/fetchExecutiveSummary';
export const SMS_DELIVERY_REPORT = 'Report/fetchDeliveryReport';
export const SMS_DELIVERY_REPORT_BETA = 'Report/deliverySummaryReport';
export const SMS_REPORT_COLUMNS = 'Report/reportColumns';
export const SMS_ENTERPRISE_IDS = 'Filters/enterpriseIds';
export const SMS_ENTERPRISE_WITH_FEEDS = 'Filters/enterpriseWithFeeds';
export const SMS_FEED_IDS = 'Filters/feedIds';
export const SMS_SENDER_IDS = 'Filters/senderIds';
export const SMS_LIVE_FEED = 'Livefeed';
export const SMS_SAVE_REPORT = 'Report/saveReport';
export const SMS_UPDATE_REPORT = 'Report/manageScheduleReport';
export const SMS_SAVED_REPORTS = 'Report/savedReport';
export const SMS_REPORT_RESEND = 'Report/resend';
export const SMS_SINGLE_REPORT_DETAIL = 'Report/singleReportDetails';
export const SMS_REPORT_UPDATE_STATUS = 'Report/updateStatus';
export const SMS_DELETE_REPORT = 'Report/delete';
export const SMS_CONNECTION_LIST = 'Connection/list';
export const SMS_CONNECTION_CREATE = 'Connection/create';
export const SMS_CONNECTION_UPDATE = 'Connection/update';
export const SMS_VERIFIED_CONNECTION = 'Connection/getVerifiedConnections';
export const SMS_TEMPLATE_LIST = 'Templates/list';
export const SMS_TEMPLATE_CREATE = 'Templates/create';
export const SMS_TEMPLATE_BULK_UPLOAD_HISTORY = 'Templates/bulkHistory';
export const SMS_TEMPLATE_BULK_UPLOAD = 'Templates/bulkUpload';
export const SMS_TEMPLATE_TEST = 'Templates/test';
export const SMS_TEMPLATE_UPDATE_STATUS = 'Templates/status';
export const SMS_SETTINGS_LIST_PE_DETAILS = 'Settings/listPEDetails';
export const SMS_SETTINGS_LIST_CONFIG_DETAILS = 'settings/listConfigDetails';
export const SMS_SETTINGS_LIST_API_ACCESS_SECURITY_DETAILS = 'settings/listApiAccessSecurityDetails';
export const SMS_SETTINGS_LIST_SENDER_ID_MANAGEMENT_DETAILS = 'settings/listSenderIdManagementDetails';
export const SMS_SETTINGS_ADD_SENDER_ID_MANAGEMENT = 'settings/addSenderIdManagement';
export const SMS_SETTINGS_UPDATE_SENDER_ID_MANAGEMENT = 'settings/updateSenderIdManagement';
export const SMS_SETTINGS_DELETE_SENDER_ID_MANAGEMENT = 'settings/deleteSenderIdManagement';
export const SMS_SETTINGS_ADD_API_ACCESS_SECURITY = 'settings/addApiAccessSecurity';
export const SMS_SETTINGS_UPDATE_API_ACCESS_SECURITY = 'settings/updateApiAccessSecurity';
export const SMS_SETTINGS_DELETE_API_ACCESS_SECURITY = 'settings/deleteApiAccessSecurity';
export const SMS_SETTINGS_LIST_LINK_TRACKING_CONFIG_DETAILS = 'settings/listLinkTrackingConfigDetails';
export const SMS_SETTINGS_LIST_LINK_TRACKING_FILTER_DOMAINS = 'settings/listLinkTrackingFilterDomains';
export const SMS_SETTINGS_DELETE_LINK_TRACKING_ATTRIBUTES = 'settings/deleteLinkTrackingAttributes';
export const SMS_SETTINGS_UPDATE_LINK_TRACKING_MASTER = 'settings/updateLinkTracking';
export const SMS_SETTINGS_ADD_CONFIG_DETAILS = 'settings/addConfigDetails';
export const SMS_SETTINGS_UPDATE_CONFIG_DETAILS = 'settings/updateConfigDetails';
export const SMS_SETTINGS_UPDATE_PE_DETAILS = 'Settings/addPEId';
export const SMS_BLOCKLIST_LOGS = 'Blocklist/bulkHistory';
export const SMS_BLOCKLIST_ADD = 'Blocklist/add';
export const SMS_BLOCKLIST_BULK_UPLOAD = 'Blocklist/upload';
export const SMS_BLOCKLIST_LIST = 'Blocklist/list';
export const SMS_GET_API_PASSWORD_DETAILS = 'settings/checkApiKeyExist';
export const SMS_SAVE_UPDATE_API_PASSWORD = 'settings/managePassword';
// SMS user meta
export const SMS_USER_META_DETAILS = 'settings/userMetaDetails';

// SMS localStorage keys
export const SMS_LS_ENTERPRISE_KEY = 'sms_enterprise_name';
export const SMS_LS_FEEDNAME_KEY = 'sms_feed_name';
export const SMS_LS_SENDERID_KEY = 'sms_sender_id';
// Cache for prepaid enterprise presence flag in SMS dashboard
export const SMS_LS_PREPAID_ENTERPRISE_PRESENT_KEY = 'sms_prepaid_enterprise_present';
// Cache for Settings/checkInternationalFeed flag (Executive Summary)
export const SMS_LS_INTERNATIONAL_FEED_STATUS_KEY = 'sms_international_feed_status';

export const RCS_ACCOUNT_USAGE = "RcsAccount/usage";
export const WHATSAPP_ACCOUNT_USAGE = "WhatsappAccount/usage"
////////////////////////////////   Code sinppet /////////////////////////////////

/*export const CURL_TEXT = 'curl --request POST \\\n' +
  '  --url https://api.pepipost.com/v2/sendEmail \\\n' +
  '  --header \'api_key: ********\' \\\n' +
  '  --header \'content-type: application/json\' \\\n' +
  '  --data \'{"personalizations":[{"recipient":"hi@welcom.com"}],"from":{"fromEmail":"xyz@yourdomain.com","fromName":"imfalconideuser"},"subject":"Welcome to Pepipost","content":"Hi, this is my first trial mail"}\'';
*/

export const CURL_TEXT = 'curl --request POST \\\n' +
  '  --url ' + API_LINK + 'v5/mail/send \\\n' +
  '  --header \'api_key: <Your API Key>\' \\\n' +
  '  --header \'content-type: application/json\' \\\n' +
  '  --data \'{"from":{"email":"confirmation@pepisandbox.com","name":"Flight confirmation"},"subject":"Your Barcelona flight e-ticket : BCN2118050657714","content":[{"type":"html","value":"Hello Lionel, Your flight for Barcelona is confirmed."}],"personalizations":[{"to":[{"email":"lionel@gmail.com","name":"Lionel Messi"}]}]}\'';




/*export const RUBY_TEXT = 'require \'uri\'\n' +
  'require \'net/http\'\n' +
  '\n' +
  'url = URI("https://api.pepipost.com/v2/sendEmail")\n' +
  '\n' +
  'http = Net::HTTP.new(url.host, url.port)\n' +
  'http.use_ssl = true\n' +
  'http.verify_mode = OpenSSL::SSL::VERIFY_NONE\n' +
  '\n' +
  'request = Net::HTTP::Post.new(url)\n' +
  'request["content-type"] = \'application/json\'\n' +
  'request["api_key"] = \'********\'\n' +
  'request.body = "{\\"personalizations\\":[{\\"recipient\\":\\"hi@welcom.com\\"}],\\"from\\":{\\"fromEmail\\":\\"xyz@yourdomain.com\\",\\"fromName\\":\\"imfalconideuser\\"},\\"subject\\":\\"Welcome to Pepipost\\",\\"content\\":\\"Hi, this is my first trial mail\\"}"\n' +
  '\n' +
  'response = http.request(request)\n' +
  'puts response.read_body';
  */

export const RUBY_TEXT = 'require \'uri\'\n' +
  'require \'net/http\'\n' +
  '\n' +
  'require \'openssl\'\n' +
  'url = URI("' + API_LINK + 'v5/mail/send")\n' +
  '\n' +
  'http = Net::HTTP.new(url.host, url.port)\n' +
  'http.use_ssl = true\n' +
  'http.verify_mode = OpenSSL::SSL::VERIFY_NONE\n' +

  'request = Net::HTTP::Post.new(url)\n' +
  'request["api_key"] = \'<Your API Key>\'\n' +
  'request["content-type"] = \'application/json\'\n' +
  'request.body = "{\\"from\\":{\\"email\\":\\"confirmation@pepisandbox.com\\",\\"name\\":\\"Flight confirmation\\"},\\"subject\\":\\"Your Barcelona flight e-ticket : BCN2118050657714\\",\\"content\\":[{\\"type\\":\\"html\\",\\"value\\":\\"Hello Lionel, Your flight for Barcelona is confirmed.\\"}],\\"personalizations\\":[{\\"to\\":[{\\"email\\":\\"lionel@gmail.com\\",\\"name\\":\\"Lionel Messi\\"}]}]}"\n' +

  'response = http.request(request)\n' +
  'puts response.read_body';

/*export const WGET_TEXT = 'wget --quiet \\\n' +
  '  --header \'content-type: application/json\' \\\n' +
  '  --header \'api_key: ********\' \\\n' +
  '  --post-data \'{"personalizations":[{"recipient":"hi@welcom.com"}],"from":{"fromEmail":"xyz@yourdomain.com","fromName":"imfalconideuser"},"subject":"Welcome to Pepipost","content":"Hi, this is my first trial mail"}\' \\\n' +
  '  --output-document \\\n' +
  '  - https://api.pepipost.com/v2/sendEmail';
*/
export const WGET_TEXT = 'wget --quiet \\\n' +
  '  --header \'api_key: <Your API Key>\' \\\n' +
  '  --header \'content-type: application/json\' \\\n' +
  '  --post-data \'{"from":{"email":"confirmation@pepisandbox.com","name":"Flight confirmation"},"subject":"Your Barcelona flight e-ticket : BCN2118050657714","content":[{"type":"html","value":"Hello Lionel, Your flight for Barcelona is confirmed."}],"personalizations":[{"to":[{"email":"lionel@gmail.com","name":"Lionel Messi"}]}]}\' \\\n' +
  '  --output-document \\\n' +
  '  - ' + API_LINK + 'v5/mail/send';



/*export const PHP_TEXT = '<?php\n' +
  '\n' +
  '$curl = curl_init();\n' +
  '\n' +
  'curl_setopt_array($curl, array(\n' +
  '  CURLOPT_URL => "https://api.pepipost.com/v2/sendEmail",\n' +
  '  CURLOPT_RETURNTRANSFER => true,\n' +
  '  CURLOPT_ENCODING => "",\n' +
  '  CURLOPT_MAXREDIRS => 10,\n' +
  '  CURLOPT_TIMEOUT => 30,\n' +
  '  CURLOPT_HTTP_VERSION => CURL_HTTP_VERSION_1_1,\n' +
  '  CURLOPT_CUSTOMREQUEST => "POST",\n' +
  '  CURLOPT_POSTFIELDS => "{\\"personalizations\\":[{\\"recipient\\":\\"hi@welcom.com\\"}],\\"from\\":{\\"fromEmail\\":\\"xyz@yourdomain.com\\",\\"fromName\\":\\"imfalconideuser\\"},\\"subject\\":\\"Welcome to Pepipost\\",\\"content\\":\\"Hi, this is my first trial mail\\"}",\n' +
  '  CURLOPT_HTTPHEADER => array(\n' +
  '    "api_key: ********",\n' +
  '    "content-type: application/json"\n' +
  '  ),\n' +
  '));\n' +
  '\n' +
  '$response = curl_exec($curl);\n' +
  '$err = curl_error($curl);\n' +
  '\n' +
  'curl_close($curl);\n' +
  '\n' +
  'if ($err) {\n' +
  '  echo "cURL Error #:" . $err;\n' +
  '} else {\n' +
  '  echo $response;\n' +
  '}';
  */

export const PHP_TEXT = '<?php\n' +
  '\n' +
  '$curl = curl_init();\n' +
  '\n' +
  'curl_setopt_array($curl, array(\n' +
  '	  CURLOPT_URL => "' + API_LINK + 'v5/mail/send",\n' +
  '	  CURLOPT_RETURNTRANSFER => true,\n' +
  '	  CURLOPT_ENCODING => "",\n' +
  '	  CURLOPT_MAXREDIRS => 10,\n' +
  '	  CURLOPT_TIMEOUT => 30,\n' +
  '	  CURLOPT_HTTP_VERSION => CURL_HTTP_VERSION_1_1,\n' +
  '	  CURLOPT_CUSTOMREQUEST => "POST",\n' +
  '	  CURLOPT_POSTFIELDS => "{\\"from\\":{\\"email\\":\\"confirmation@pepisandbox.com\\",\\"name\\":\\"Flight confirmation\\"},\\"subject\\":\\"Your Barcelona flight e-ticket : BCN2118050657714\\",\\"content\\":[{\\"type\\":\\"html\\",\\"value\\":\\"Hello Lionel, Your flight for Barcelona is confirmed.\\"}],\\"personalizations\\":[{\\"to\\":[{\\"email\\":\\"lionel@gmail.com\\",\\"name\\":\\"Lionel Messi\\"}]}]}",\n' +
  '	  CURLOPT_HTTPHEADER => array(\n' +
  '    "api_key: <Your API Key>",\n' +
  '    "content-type: application/json"\n' +
  '  ),\n' +
  '));\n' +

  '$response = curl_exec($curl);\n' +
  '$err = curl_error($curl);\n' +
  '\n' +
  'curl_close($curl);\n' +
  '\n' +
  'if ($err) {\n' +
  ' echo "cURL Error #:" . $err;\n' +
  '} else {\n' +
  '	  echo $response;\n' +
  '}';


/*export const PYTHON_TEXT = 'import requests\n' +
  '\n' +
  'url = "https://api.pepipost.com/v2/sendEmail"\n' +
  '\n' +
  'payload = "{\\"personalizations\\":[{\\"recipient\\":\\"hi@welcom.com\\"}],\\"from\\":{\\"fromEmail\\":\\"xyz@yourdomain.com\\",\\"fromName\\":\\"imfalconideuser\\"},\\"subject\\":\\"Welcome to Pepipost\\",\\"content\\":\\"Hi, this is my first trial mail\\"}"\n' +
  'headers = {\n' +
  '    \'content-type\': "application/json",\n' +
  '    \'api_key\': "********"\n' +
  '    }\n' +
  '\n' +
  'response = requests.request("POST", url, data=payload, headers=headers)\n' +
  '\n' +
  'print(response.text)';
*/

export const PYTHON_TEXT = 'import requests\n' +
  '\n' +
  'url = "' + API_LINK + 'v5/mail/send"\n' +
  '\n' +
  'payload = "{\\"from\\":{\\"email\\":\\"confirmation@pepisandbox.com\\",\\"name\\":\\"Flight confirmation\\"},\\"subject\\":\\"Your Barcelona flight e-ticket : BCN2118050657714\\",\\"content\\":[{\\"type\\":\\"html\\",\\"value\\":\\"Hello Lionel, Your flight for Barcelona is confirmed.\\"}],\\"personalizations\\":[{\\"to\\":[{\\"email\\":\\"lionel@gmail.com\\",\\"name\\":\\"Lionel Messi\\"}]}]}"\n' +
  'headers = {\n' +
  ' 	\'api_key\': "<Your API Key>",\n' +
  ' 	\'content-type\': "application/json"\n' +
  ' 	}\n' +
  '\n' +
  'response = requests.request("POST", url, data=payload, headers=headers)\n' +
  '\n' +
  'print(response.text)';




/*export const JAVA_TEXT = 'HttpResponse<String> response = Unirest.post("https://api.pepipost.com/v2/sendEmail")\n' +
  '  .header("content-type", "application/json")\n' +
  '  .header("api_key", "********")\n' +
  '  .body("{\\"personalizations\\":[{\\"recipient\\":\\"hi@welcom.com\\"}],\\"from\\":{\\"fromEmail\\":\\"xyz@yourdomain.com\\",\\"fromName\\":\\"imfalconideuser\\"},\\"subject\\":\\"Welcome to Pepipost\\",\\"content\\":\\"Hi, this is my first trial mail\\"}")\n' +
  '  .asString();';
*/

export const JAVA_TEXT = 'HttpResponse<String> response = Unirest.post("' + API_LINK + 'v5/mail/send")\n' +
  '  .header("api_key", "<Your API Key>")\n' +
  '  .header("content-type", "application/json")\n' +
  '  .body("{\\"from\\":{\\"email\\":\\"confirmation@pepisandbox.com\\",\\"name\\":\\"Flight confirmation\\"},\\"subject\\":\\"Your Barcelona flight e-ticket : BCN2118050657714\\",\\"content\\":[{\\"type\\":\\"html\\",\\"value\\":\\"Hello Lionel, Your flight for Barcelona is confirmed.\\"}],\\"personalizations\\":[{\\"to\\":[{\\"email\\":\\"lionel@gmail.com\\",\\"name\\":\\"Lionel Messi\\"}]}]}")\n' +
  '  .asString();';



/*export const CSHARP_TEXT = 'var client = new RestClient("https://api.pepipost.com/v2/sendEmail");\n' +
  'var request = new RestRequest(Method.POST);\n' +
  'request.AddHeader("api_key", "********");\n' +
  'request.AddHeader("content-type", "application/json");\n' +
  'request.AddParameter("application/json", "{\\"personalizations\\":[{\\"recipient\\":\\"hi@welcom.com\\"}],\\"from\\":{\\"fromEmail\\":\\"xyz@yourdomain.com\\",\\"fromName\\":\\"imfalconideuser\\"},\\"subject\\":\\"Welcome to Pepipost\\",\\"content\\":\\"Hi, this is my first trial mail\\"}", ParameterType.RequestBody);\n' +
  'IRestResponse response = client.Execute(request);';*/

export const CSHARP_TEXT = 'var client = new RestClient("' + API_LINK + 'v5/mail/send");\n' +
  'var request = new RestRequest(Method.POST);\n' +
  'request.AddHeader("api_key", "<Your API Key>");\n' +
  'request.AddHeader("content-type", "application/json");\n' +
  'request.AddParameter("application/json", "{\\"from\\":{\\"email\\":\\"confirmation@pepisandbox.com\\",\\"name\\":\\"Flight confirmation\\"},\\"subject\\":\\"Your Barcelona flight e-ticket : BCN2118050657714\\",\\"content\\":[{\\"type\\":\\"html\\",\\"value\\":\\"Hello Lionel, Your flight for Barcelona is confirmed.\\"}],\\"personalizations\\":[{\\"to\\":[{\\"email\\":\\"lionel@gmail.com\\",\\"name\\":\\"Lionel Messi\\"}]}]}", ParameterType.RequestBody);\n' +
  'IRestResponse response = client.Execute(request);';





/*export const GO_TEXT = 'package main\n' +
  '\n' +
  'import (\n' +
  '\t"fmt"\n' +
  '\t"strings"\n' +
  '\t"net/http"\n' +
  '\t"io/ioutil"\n' +
  ')\n' +
  '\n' +
  'func main() {\n' +
  '\n' +
  '\turl := "https://api.pepipost.com/v2/sendEmail"\n' +
  '\n' +
  '\tpayload := strings.NewReader("{\\"personalizations\\":[{\\"recipient\\":\\"hi@welcom.com\\"}],\\"from\\":{\\"fromEmail\\":\\"xyz@yourdomain.com\\",\\"fromName\\":\\"imfalconideuser\\"},\\"subject\\":\\"Welcome to Pepipost\\",\\"content\\":\\"Hi, this is my first trial mail\\"}")\n' +
  '\n' +
  '\treq, _ := http.NewRequest("POST", url, payload)\n' +
  '\n' +
  '\treq.Header.Add("content-type", "application/json")\n' +
  '\treq.Header.Add("api_key", "********")\n' +
  '\n' +
  '\tres, _ := http.DefaultClient.Do(req)\n' +
  '\n' +
  '\tdefer res.Body.Close()\n' +
  '\tbody, _ := ioutil.ReadAll(res.Body)\n' +
  '\n' +
  '\tfmt.Println(res)\n' +
  '\tfmt.Println(string(body))\n' +
  '\n' +
  '}';
  */

export const GO_TEXT = 'package main\n' +
  '\n' +
  'import (\n' +
  '	"fmt"\n' +
  '	"strings"\n' +
  '	"net/http"\n' +
  '	"io/ioutil"\n' +
  ')\n' +
  '\n' +
  'func main() {\n' +
  '\n' +
  '	url := "' + API_LINK + 'v5/mail/send"\n' +
  '\n' +
  '	payload := strings.NewReader("{\\"from\\":{\\"email\\":\\"confirmation@pepisandbox.com\\",\\"name\\":\\"Flight confirmation\\"},\\"subject\\":\\"Your Barcelona flight e-ticket : BCN2118050657714\\",\\"content\\":[{\\"type\\":\\"html\\",\\"value\\":\\"Hello Lionel, Your flight for Barcelona is confirmed.\\"}],\\"personalizations\\":[{\\"to\\":[{\\"email\\":\\"lionel@gmail.com\\",\\"name\\":\\"Lionel Messi\\"}]}]}")\n' +
  '\n' +
  '	req, _ := http.NewRequest("POST", url, payload)\n' +
  '\n' +
  '	req.Header.Add("api_key", "<Your API Key>")\n' +
  '	req.Header.Add("content-type", "application/json")\n' +
  '\n' +
  '	res, _ := http.DefaultClient.Do(req)\n' +
  '\n' +
  '	defer res.Body.Close()\n' +
  '	body, _ := ioutil.ReadAll(res.Body)\n' +
  '\n' +
  '	fmt.Println(res)\n' +
  '	fmt.Println(string(body))\n' +
  '\n' +
  '}';

/*export const JAVASCRIPT_XML_HTTP_TEXT = 'var data = JSON.stringify({\n' +
  '  "personalizations": [\n' +
  '    {\n' +
  '      "recipient": "hi@welcom.com"\n' +
  '    }\n' +
  '  ],\n' +
  '  "from": {\n' +
  '    "fromEmail": "xyz@yourdomain.com",\n' +
  '    "fromName": "imfalconideuser"\n' +
  '  },\n' +
  '  "subject": "Welcome to Pepipost",\n' +
  '  "content": "Hi, this is my first trial mail"\n' +
  '});\n' +
  '\n' +
  'var xhr = new XMLHttpRequest();\n' +
  'xhr.withCredentials = true;\n' +
  '\n' +
  'xhr.addEventListener("readystatechange", function () {\n' +
  '  if (this.readyState === this.DONE) {\n' +
  '    console.log(this.responseText);\n' +
  '  }\n' +
  '});\n' +
  '\n' +
  'xhr.open("POST", "https://api.pepipost.com/v2/sendEmail");\n' +
  'xhr.setRequestHeader("content-type", "application/json");\n' +
  'xhr.setRequestHeader("api_key", "********");\n' +
  '\n' +
  'xhr.send(data);';
  */

export const JAVASCRIPT_XML_HTTP_TEXT = 'var data = JSON.stringify({\n' +
  '"from": {\n' +
  '  "email": "confirmation@pepisandbox.com",\n' +
  '  "name": "Flight confirmation"\n' +
  '},\n' +
  '"subject": "Your Barcelona flight e-ticket : BCN2118050657714",\n' +
  '"content": [\n' +
  ' {\n' +
  '    "type": "html",\n' +
  '    "value": "Hello Lionel, Your flight for Barcelona is confirmed."\n' +
  '  }\n' +
  '],\n' +
  ' "personalizations": [\n' +
  ' {\n' +
  '    "to": [\n' +
  '      {\n' +
  '        "email": "lionel@gmail.com",\n' +
  '        "name": "Lionel Messi"\n' +
  '		}\n' +
  '    ]\n' +
  '  }\n' +
  ' ]\n' +
  '});\n' +

  'var xhr = new XMLHttpRequest();\n' +
  'xhr.withCredentials = true;\n' +
  '\n' +
  'xhr.addEventListener("readystatechange", function () {\n' +
  ' if (this.readyState === this.DONE) {\n' +
  '  console.log(this.responseText);\n' +
  '}\n' +
  '});\n' +

  'xhr.open("POST", "' + API_LINK + 'v5/mail/send");\n' +
  'xhr.setRequestHeader("api_key", "<Your API Key>");\n' +
  'xhr.setRequestHeader("content-type", "application/json");\n' +
  '\n' +
  'xhr.send(data);';

/*export const NODE_TEXT = 'var http = require("https");\n' +
  '\n' +
  'var options = {\n' +
  '  "method": "POST",\n' +
  '  "hostname": "api.pepipost.com",\n' +
  '  "port": null,\n' +
  '  "path": "/v2/sendEmail",\n' +
  '  "headers": {\n' +
  '    "content-type": "application/json",\n' +
  '    "api_key": "********"\n' +
  '  }\n' +
  '};\n' +
  '\n' +
  'var req = http.request(options, function (res) {\n' +
  '  var chunks = [];\n' +
  '\n' +
  '  res.on("data", function (chunk) {\n' +
  '    chunks.push(chunk);\n' +
  '  });\n' +
  '\n' +
  '  res.on("end", function () {\n' +
  '    var body = Buffer.concat(chunks);\n' +
  '    console.log(body.toString());\n' +
  '  });\n' +
  '});\n' +
  '\n' +
  'req.write(JSON.stringify({ personalizations: [ { recipient: \'hi@welcom.com\' } ],\n' +
  '  from: { fromEmail: \'xyz@yourdomain.com\', fromName: \'imfalconideuser\' },\n' +
  '  subject: \'Welcome to Pepipost\',\n' +
  '  content: \'Hi, this is my first trial mail\' }));\n' +
  'req.end();';
*/

export const NODE_TEXT = 'var http = require("https");\n' +
  '\n' +
  'var options = {\n' +
  '  "method": "POST",\n' +
  '  "hostname": "emailapi.netcorecloud.net",\n' +
  '  "port": null,\n' +
  '  "path": "/v5/mail/send",\n' +
  '  "headers": {\n' +
  '    "api_key": "<Your API Key>",\n' +
  '    "content-type": "application/json"\n' +
  '  }\n' +
  '};\n' +
  '\n' +
  'var req = http.request(options, function (res) {\n' +
  '  var chunks = [];\n' +
  '\n' +
  '  res.on("data", function (chunk) {\n' +
  '    chunks.push(chunk);\n' +
  '  });\n' +
  '\n' +
  '  res.on("end", function () {\n' +
  '    var body = Buffer.concat(chunks);\n' +
  '   console.log(body.toString());\n' +
  '  });\n' +
  '});\n' +
  '\n' +
  'req.write(JSON.stringify({\n' +
  '  from: {email: \'confirmation@pepisandbox.com\', name: \'Flight confirmation\'},\n' +
  '  subject: \'Your Barcelona flight e-ticket : BCN2118050657714\',\n' +
  '  content: [{type: \'html\', value: \'Hello Lionel, Your flight for Barcelona is confirmed.\'}],\n' +
  '  personalizations: [{to: [{email: \'lionel@gmail.com\', name: \'Lionel Messi\'}]}]\n' +
  '}));\n' +
  'req.end();';


// Appcues Constants
export const APPCUE_STORAGE_KEY = 'apc_local_store_';
export const EVENT_ACC_ACTIVE = 'account_activation';      // user done with account activation
export const EVENT_DOMAIN_ADD = 'domain_addition';         // user done with domain addition
export const EVENT_DOMAIN_VERIFY = 'domain_verification';     // user's added domain is approved
export const EVENT_EMAIL_SENT = 'email_sent';              // user sent atleast one email
export const EVENT_VISIT_BILLING_PG = 'visit_billing_page';            // user visited billing page
export const EVENT_VISIT_INTEGRATION_PG = 'visit_integration_page';         // user visited integration page
export const EVENT_VISIT_DOM_VER_PG = 'visit_domain_verification_page';  // user visited domain verification page
export const EVENT_VISIT_PLAN_UP_PG = 'visit_upgrade_plan_page';         // user visited upgrade plan page
export const EVENT_VISIT_IP_DED_PG = 'visit_dedicated_ip_page';         // user visited dedicated ip page


// Email Marketing
export const EVENT_VISIT_MARKETING_PAGE = 'Pepiapi/sendMail_MarketingLinkTrack';   // user visited marketing page then send mail activity



/*
  Added By- Akshay J
  Email - akshay.jadhav@pepipost.com
  For Role Based Access define menues, submenues, page tabs with their ids
  You can find respective Id's in mysql tables named trans_role_menu_master, trans_role_submenu_masters,
  trans_role_pagetab_masters respectively for any clarification contact me
*/

// Subuser Role Names

export const USER_ROLE_OBJECT = {
  1: "Admin", 2: "Accounts", 3: "Analytics", 4: "Support", 5: "Tech",
  6: "Design", 7: "Marketing", 8: "Suppression"
};

// menu items refer table - trans_role_menu_master
export const MENU_ITEMS_IDs = {
  dashboard: "1", live: "2", analytics: "3", suppression: "4", 'email-marketing': "5",
  billings: "6", settings: "7", whatsapp: "8",template:"9"
};

// add menu id wise submenus refer table - trans_role_submenu_master
//{ meun_id : { submenu_url : submenu_id } }
export const SUB_MENU_ITEMS_IDs = {
  3: {
    "mail-summary": "1", "subaccount-analytics": "2",
    "reports": "31", "saved-schedule-report": "32", "insights": "34"
  },
  6: { "details": "3", "enterprise-billing": "4", "subaccount-log": "5", "credit-management": "6", "bucketwise-billing": "7", "postpaid-billing": "8", "subaccount-billing": "9", "account-log": "10", "postpaid-credit-management": "12", "dedicated-ip": "13" },
  7: { 'domain': "15", 'sandbox': "16", 'integration': "17", 'mail-settings': "18", 'webhooks': "19", 'manage-tags': "20", 'sub-accounts': "21",  'sub-user-management': "23", 'warmup': "24", 'mail-alerts': "25", 'inbound-parsing': "33", 'general-settings': "35" ,'template':"38"},
  8: { 'profile': "26", 'consent-management': "27", 'templates': "28", 'reports': "29", 'settings': "30" },
  9: { 'email-template': "36", 'template': "37" }
};

export const PAGE_TABS_ITEMS_IDs = {
  3: { 'recharge': "3", 'information': "4", 'history': "5" },
  5: { 'usage-summary': "6", 'credit-log': "7" },
  6: { 'redeem': "8", 'redeem-history': "9" },
  8: { 'payment': "10", 'transactions': "11", 'history': "12" },
  34: { 'funnel-performance': "28", 'health-score': "29", "deliverability": "30", "engagement": "31" },
  38: { 'edit': "31",'preview':'32' }
};

export const CHECK_SUBUSER_LOGIN = 'Subuser/isLoginSubuser';
export const GET_SUBUSER_ROLE_INFO = 'Subuser/getRoleWiseAccess';
export const LIST_SUBUSERS_DETAILS = 'Subuser/list';
export const GET_ROLE_WISE_DATA = 'Subuser/getRoleWiseData';
export const CREATE_ROLE_USER = 'Subuser/CreateUser';
export const EDIT_ROLE_USER = 'Subuser/EditUser';
export const GET_SUBUSER_ENTERPRISES = 'Subuser/getSubuserEnterprises';
export const ROLES_LIST = 'Roles/roles_list';
export const GET_USER_PERMISSIONS = 'Roles/user_permissions';
export const SUBUSER_RESEND_LINK = 'Subuser/subuserResendConfirmation';
export const DELETE_ROLE_USER = 'Subuser/DeleteUser';


///////////////////////// Constants for Reporting module //////////////////////////////////

export const FETCH_REPORT = 'report/fetchReport';

export const FETCH_SAVED_REPORT_DETAILS = 'report/fetchSavedReportList';
export const FETCH_CONNECTION_DETAILS = 'report/fetchConnectionDetails';
export const UPDATE_SCHEDULING_STATUS = 'report/updateStatus';
export const SAVE_REPORT = 'report/saveReport';
export const SET_REPORTING_PASSWORD = 'Profile/setReportingPassword';
export const CHECK_REPORTING_PASSWORD_SET = 'Profile/checkReportingPasswordSet';
export const GET_REPORTING_PASSWORD = 'Profile/reportingPassword';
export const FETCH_VERFIED_CONNECTION = 'report/fetchVerfiedConnection';
export const WHITELIST_IP = '35.188.246.213, 34.85.173.237';
export const WHITELIST_IP_EU = '34.90.163.225';
export const CREATE_CONNECTION_FOR_REPORTS = 'report/saveConnectionDetails';
export const UPDATE_CONNECTION_FOR_REPORTS = 'report/updateConnection';
export const GET_SINGLE_REPORT_DETAILS = 'report/signleReportDetails';
export const SINGLE_REPORT_DETAILS = 'report/signleReportDetails';
export const REPORT_RESEND_CONFIRMATION = 'report/resend';
export const UPDATE_SCHEDULE_REPORT = 'report/manageScheduleReport';
export const DELETE_REPORT = 'report/deleteReport';
export const SCHEDULED_REPORT_STATUS_LOGS = 'report/reportStatus';
export const REPORT_RESEND = 'report/retryScheduleReport';


///////////////////////// Constants for Insights module //////////////////////////////////


export const GET_INSIGHTS_PAGE_ACESS = 'Insights/checkInsightsAccess';
export const GET_INSIGHTS_FUNNEL_TABLE = 'Insights/getFunnelTableData';
export const GET_INSIGHTS_DATA = 'Insights/getInsightsData';
export const GET_SPILLOVER_REPORT = 'insights';
export const POST_INSIGHTS_API_LOGS = 'Insights/logging_api_time';
export const GET_LATENCY_DATA = 'insights/getLatencyData';
export const FETCH_FUNNEL_CHARTS_DATA = 'Insights/fetch_funnel_charts';
export const GET_LATENCY_TABLE_DATA = 'insights/getLatencyReport';
export const GET_SPILLOVER_DATA = 'insights/getSpillOverPageData';
export const GET_POSTMASTER_DASHBOARD = 'insights/deliverabilityDashboard';
// export const GET_POSTMASTER_TABLE_DATA = 'insights/fetchPostmasterData';
export const GET_POSTMASTER_TABLE_DATA = 'insights/postmasterGrid';

export const GET_DISSOCIATION_RATE = 'insights/getDissociationDetails';
export const GET_RECENCY_TABLE_DATA = 'insights/getRecencyDetails';
export const FETCH_RECENCY = 'insights/getRecency';
export const DOWNLOAD_CONTACTS = 'insights/downloadContacts';
export const GET_ENGAGEMENT_RATE = 'insights/fetch_engagementRate_charts';
export const GET_ENGAGEMENT_TIME_CHART = 'insights/fetch_engagementTime_charts';
export const GET_ENGAGEMENT_TIME_TABLE = 'insights/getEngagementTimeTableData';


export const LIST_ALL_API_KEY = "Integrations/listApiKey";
export const CREATE_CUSTOM_API = "Integrations/newApiKey";
export const DELETE_CUSTOM_API = "Integrations/removeApikey";
export const LIST_API = "Integrations/listApi";
export const FETCH_API_PERMISSION = "Integrations/listPermission";
export const FETCH_INBOXABLE_DATA = 'insights/inboxDetails';
export const FETCH_INBOXABLE_TABLE_DATA = 'insights/inboxTableDetails';
export const FETCH_INBOXABLE_ISP_TABLE_DATA = 'insights/inboxISPDetails';
export const FETCH_DOMAINWISE_HEALTH_SCORE_DETAILS = 'insights/fetchCompwiseScore';
export const FETCH_HEALTH_SCORE_DETAILS = 'insights/fetchHealthScore';


///////////////////////// Constants for Inbound Parsing module //////////////////////////////////
export const GET_INBOUND_PARSE_DATA = 'Inbound/getParserData';
export const GET_INBOUND_REPORTS_DATA = 'Inbound/getReplyReportsData';
export const ADD_INBOUND_PARSE_DATA = 'Inbound/addParserData';
export const GET_INBOUND_PARSE_CONDITIONS = 'Inbound/getParserConditions';
export const UPDATE_INBOUND_PARSE_DATA = 'Inbound/updateParserData';
export const GET_INBOUND_FORM_CONDITIONS = 'Inbound/getParserFormsConditions';
export const GET_INBOUND_FORM_ACTIONS = 'Inbound/getParserFormsActions';
export const PEPI_INBOUND_DOMAIN = 'inbound.pepipost.com';   // domain name where client needs to do mx record
export const CHECK_DOMAIN_MX_RECORD = 'Domain/verify_mx_record';
export const GET_ADD_INBOUND_DOMAINS = 'Inbound/getAddParseClientDomains';  // clients domains eligible while create parsing
export const GET_EDIT_INBOUND_DOMAINS = 'Inbound/getEditParseClientDomains'; // clients domains eligible while editing parsing
export const DELETE_INBOUND_PARSE_DATA = 'Inbound/deleteParserData';
export const INBOUND_CNAME_DOMAIN = 'inbound.netcorecloud.net';   // domain where client needs to do add CNAME for inbound parsing
export const INBOUND_CNAME_DOMAIN_EU = 'inbound.eapi.eu.netcorecloud.net';   // domain where client needs to do add CNAME for inbound parsing
export const CHECK_DOMAIN_INBOUND_RECORD = 'Inbound/verify_inbound_cname';


///////////////////////// Constants for Home Dashboard //////////////////////////////////
export const GET_HOME_DASHBOARD_DATA = 'Dashboard/getHomeSetting';
export const UPDATE_HOME_DASHBOARD_DATA = 'Dashboard/updateHomeSetting';

export const LOGIN_STATUS = 'login/loginStatus';
export const REDIRECT_NEWUI = 'login/redirect';
export const HEALTHSCORE_ALL_DOMAIN_LIST = 'sandbox/domainlist';
export const ALLOWED_WIDGET_PAGE_URLS = ['/dashboard'];

////////// Constants for Insight Report discoverability ////////////////////////////////
export const CONTACT_US_EMAIL = "help@netcorecloud.com";

export const SWITCH_ACCOUNT = "login/switch_account";
export const SUB_ACCOUNT_LIST = "login/subaccounts_list";
export const SUBACCOUNT_SWITCH = "Login/subaccountSwitch";

//////////WHATSAPP Mail alert///////////////////////////////////////

export const SAVE_MAIL_ALERT = "Alerts/add_alert";
export const CLIENT_ALERT_LIST  = "Alerts/client_alerts";
export const LIST_ALERT = "Alerts/list_alerts";
export const DELETE_WA_ALERT = "Alerts/delete_alert";
export const LIST_SUB_ALERT = "Alerts/list_alerts_sub_types";
////////// MULTI PRODUCT Constants/////////////////////////////

export const SET_PRODUCT_TYPE = "product";
export const SET_PRODUCT_SETUP = "product/setup"
export const GET_SINGLE_CHANNEL_SETTING = "product/getChannelSetting";
export const GET_PRODUCT_WEBHOOK_SETTING = "product/getWebhookSetting"
export const SET_PRODUCT_WEBHOOK_SETTING = "product/setWebhookSetting"
export const GET_PRODUCTS_LIST = "product/list"
////////// Constants for Whatsapp Campaign /////////////////////////////
export const WHATSAPP_TEMPLATE_LIST = "template/getTemplateList";
export const WHATSAPP_TEMPLATE_DETAIL ="template/temp_preview";
export const WHATSAPP_CAMPAIGN_UPLOAD = "campaign/saveCamp";
export const WHATSAPP_CAMPAIGN_TEMPLATE_DETAIL = "template/camp_preview";
export const WHATSAPP_CAMPAIGN_LIST = "report/camp_report";
export const WHATSAPP_CAMPAIGN_INQUEUE_LIST = "report/inqueue_report";
export const WHATSAPP_CAMPAIGN_FAILED_LIST = "report/failed_report";
export const WHATSAPP_TAGS_LIST = "report/fetch_tags";

////////// Constants for Whatsapp Billing /////////////////////////////
export const GET_WHATSAPP_BILLING_COUNT = 'Billing/get_graph_counts';
export const GET_WHATSAPP_BILLING_TABLE = 'Billing/get_billing_table';

////////// Constants for Whatsapp Billing V1 /////////////////////////////
export const GET_WHATSAPP_BILLING_COUNT_V1 = 'billing/get_graph_counts_v1';
export const GET_COUNTRIES_V1 = 'billing/get_country';
//////////Whatsapp schedule report///////////////////////////////////


export const GET_SCHEDULE_REPORT = "report/getScheduledReports";
export const UPDATE_SCHEDULE_STATUS = "report/updateStatus";
export const GET_CONNECTION_REPORT = "report/getConnections";
export const SAVE_SCHEDULE_REPORT = "report/saveReport";
export const SAVE_CONNECTION_REPORT = "report/saveConnection";
export const GET_SINGLE_REPORT_DETAIL = "report/getReportDetails";
export const GET_SINGLE_CONNECTION_DETAIL = "report/getConnection";
export const GET_VERIFIED_CONNECTION = "report/getVerifiedConnections";
export const RESEND_REPORT = "report/resend";
export const DELETE_WHATSAPP_REPORT = "report/delete";

//////// RCS Opt in ////////////////
export const GET_OPT_LIST = 'opt/list';

export const GET_RCS_BILLING_COUNT_V1 = 'RcsBilling/getGraphCount';
export const GET_RCS_BILLING_TABLE = 'RcsBilling/getBillingTable';
export const RCS_RENAME_TEMPLATE = 'RcsTemplate/renameTemplate';
export const GET_RCS_TAG_LIST ='RcsBilling/getTagList';
export const RCS_TAGS_LIST = "report/fetch_tags";

//whatsapp settings click config
export const CLICK_CONFIG_GET = 'setting/click_config';
export const CLICK_CONFIG_POST = 'setting/update_click_config';
export const CNAME_VERIFICATION = 'setting/cname_verfication';
export const CNAME_VERIFICATION_FOR_SMS = 'settings/cname_verfication';

export const UPDATE_DOMAIN_POST = 'setting/update_domain';

export const GET_BOT_LIST = 'setting/get_bots';
//// const for RCS start stop message ////////////////
export const GET_PRODUCT_DEFAULT_MESSAGE = "product/getDefaultMsgData"
export const UPDATE_PRODUCT_DEFAULT_MESSAGE = "product/updateDefaultMsgData"


/// whatsapp timezone

export const GET_TIMEZONE = "setting/get_timezone"
export const GET_CLIENT_CONFIG = "setting/get_client_config"
export const GET_CONFIG_DETAILS = 'setting/configDetails'
export const DEFAULT_WA_TIMEZONE = "Asia/Calcutta"

//RCS campaign API//////////////////////////////////

export const GET_CAMPAIGN_LIST = "report/soipSummaryReport";
export const GET_CAMPAIGN_LIST_PROCESSIJNG = 'report/inprocess_report';
export const GET_CAMPAIGN_LIST_FAILED = 'report/failed_report';
export const RCS_SAVE_CAMPAIGN = "campaign/savecamp";

//Deflector Dashboard
export const DEFLECTOR_DASHBOARD_HISTORY_GRAPH = 'deflector/fetchDashboardData';
export const DEFLECTOR_FETCH_REPORT = "deflectorReport/fetchReport";
///////////////////////RCS Blocklist API ////////////////////////////
export const GET_RCS_BLOCKLIST = "blocklist/get_blocklist";
export const SAVE_RCS_BLOCKLIST = "blocklist/add_blocklist";
export const RCS_WHITELIST = "blocklist/whitelist";
export const DOWNLOAD_BLOCKLIST = "blocklist/download_report";

//RCS schdeule reporting/////
export const SAVE_RCS_SCHEDULE_REPORT = "RcsScheduleReport/saveReport";
export const RCS_FETCH_SCHEDULE_REPORT = "RcsScheduleReport/getScheduledReports";
export const RCS_RESEND_REPORT = "RcsScheduleReport/resend";
export const RCS_SINGLE_REPORT_DETAIL = "RcsScheduleReport/getReportDetails";
export const RCS_UPDATE_SCHEDULING_STATUS = 'RcsScheduleReport/updateStatus';
export const DELETE_RCS_REPORT = "RcsScheduleReport/delete";
export const SAVE_RCS_CONNECTION_REPORT = "RcsScheduleReport/saveConnection";
export const RCS_GET_CONNECTION_REPORT = "RcsScheduleReport/getConnections";
export const RCS_SINGLE_CONNECTION_DETAIL = "RcsScheduleReport/getConnection";
export const RCS_GET_VERIFIED_CONNECTION = "RcsScheduleReport/getVerifiedConnections";

//MMLite
export const DISABLE_MMLITE = 'setting/disable_mmlite';
// sender email auth
export const ADD_SENDER_EMAIL = 'senderEmail/add_senderemail';
export const SENDER_EMAIL_LIST = 'senderEmail/senderemaillist';
export const UPDATE_SENDER_EMAIL = 'senderEmail/update_senderemail';
export const DELETE_SENDER_EMAIL = 'senderEmail/delete_senderemail';
export const UPADTE_SENDER_AUTH_STATUS = 'senderEmail/updatesettingvalue';
export const VERIFY_SENDER_EMAIL = 'senderEmail/verify_senderemail';

export const API_SUCCESS_RESPONSE = 'success';
